import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { PdfTemplateContext } from '../../../../../../context/PdfTemplateContext';
import { PdfTemplateEntityType } from '../../../../../../types/pdf_template';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../types/translation/Translator';
import { Routing } from '../../../../../../util/routes.util';
import { CreateButton } from '../../../../../components/Button';
import { Card } from '../../../../../components/Card';
import { NoItemsFound } from '../../../../../components/NoItems';
import { Searchbar } from '../../../../../components/TextInput';
import Icon, { IconType } from '../../../../../icons/Icon';

export default function OrderPdfTemplatesPane() {
  const navigate = useNavigate();
  const { pdfTemplates } = useContext(PdfTemplateContext);

  const [query, setQuery] = React.useState<string>('');

  const items = [...pdfTemplates.values()].filter(p => p.entityType === PdfTemplateEntityType.order);

  return (
    <div className='content-x flex h-full flex-col gap-4'>
      <div className='flex justify-between gap-2'>
        <Searchbar value={query} onChange={value => setQuery(value)} />
        <CreateButton onClick={() => navigate(Routing.pdfTemplateEditor.create(PdfTemplateEntityType.order))} />
      </div>
      {items.length ? (
        <div className='flex flex-wrap gap-4'>
          {items.map(item => (
            <Card size={'md'} onClick={() => navigate(Routing.pdfTemplateEditor.update(item.id))} key={item.id}>
              <div className='grid place-items-center gap-2 text-center'>
                <div className='grid place-items-center gap-1'>
                  <Icon type={IconType.dataFlow1} stroke={'stroke-black'} size={'size-5'} />
                  <p className='text-sm font-medium text-title'>{item.name}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <div className='flex flex-grow items-center justify-center'>
          <NoItemsFound icon={IconType.settings4} title={t(TranslationKey.noPdfTemplateYetTitle).singular.upper} />
        </div>
      )}
    </div>
  );
}
